import request from './request'
// 获取顶部菜单

export function getMenuData(data){
    let url = "/api/DirectoryCategory/GetMainDirs";
    return request({
        url: url,
        method: 'post',
        data
    });
}


// WEBPACK FOOTER //
// ./src/assets/js/modules/topMenu.js